<template>
  <div class="service-signatures">
    <NewSignatureDialog v-if="dialog_signature.status" :open="dialog_signature.status" @close-dialog="closeNewSignatureDialog" />

    <TakeBringDialog
      v-if="dialog_take_bring.status && app_mode === 'advanced'"
      :open="dialog_take_bring.status"
      @close-dialog="closeTakeBringDialog"
    />

    <LinkBudgetDialog
      v-if="dialog_link_budget.status && app_mode === 'advanced'"
      :open="dialog_link_budget.status"
      @close-dialog="closeLinkBudgetDialog"
      @close-and-create-budget="openBudgetDialog"
    />

    <v-bottom-sheet v-model="view_signature.status">
      <div class="signed-dialog" v-if="view_signature.signature">
        <div class="s-header">
          <div class="action-btn">
            <v-icon @click="closeSignatureDialog()" color="white" size="22">mdi-close</v-icon>
          </div>
          <div class="action-btn mr-3" v-if="view_signature.signature.signature_method === 'link' && view_signature.signature.signed_pdf_url === null">
            <v-dialog v-model="dialog_signature_disable.status" :persistent="dialog_signature_disable.loading">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" color="white" size="22">mdi-delete</v-icon>
              </template>
              <v-card class="pb-2">
                <v-card-title class="text-h5"> Desativar assinatura ? </v-card-title>
                <v-card-text
                  >Por segurança, nenhuma assinatura é totalmente excluida. A assinatura será apenas desativada, podendo ser reativada a qualquer
                  momento mediante a solicitação.</v-card-text
                >
                <v-card-actions>
                  <v-btn color="green darken-1" outlined @click="dialog_signature_disable.status = false" :disabled="dialog_signature_disable.loading"> Cancelar </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="error" outlined @click="disableSignature(view_signature.signature.id)" :loading="dialog_signature_disable.loading"> Desativar assinatura </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
          <div class="whatsapp-share mr-3">
            <v-icon @click="whatsappShareSignature()" color="white" size="22">mdi-whatsapp</v-icon>
          </div>
          <h2>{{ view_signature.signature.title }}</h2>
        </div>
        <div class="s-tabs">
          <v-tabs :show-arrows="false" v-model="view_signature.tab" fixed-tabs align-with-title background-color="#F5F5F5" color="#48B38B">
            <v-tabs-slider color="#48B38B"></v-tabs-slider>
            <v-tab> Termo assinado </v-tab>
            <v-tab> Informações </v-tab>
          </v-tabs>
        </div>
        <div class="s-content">
          <v-tabs-items v-model="view_signature.tab">
            <v-tab-item>
              <div class="s-ginature-term">
                <div v-html="replaceDescription(view_signature.signature.description)"></div>
              </div>
              <div class="s-signature-area">
                <img v-if="view_signature.signature.signed_pdf_hash" :src="view_signature.signature.signature_image" style="margin-bottom: 1px;" />
                <v-alert v-else icon="mdi-draw-pen" style="text-align: center; margin-bottom: 0px" dense prominent text color="#48B38B">
                  <div v-if="view_signature.signature.signature_method === 'link'">
                    Link para assinatura enviado. Aguardando assinatura do cliente.
                  </div>
                  <div v-else>
                    Assinatura em processamento, verifique mais tarde.
                  </div>
                </v-alert>
                __________________________________________<br />
                <b>{{ view_signature.signature.signing_name }}</b> <br />
                <small v-if="view_signature.signature.signature_image_at"
                  >{{ new Date(view_signature.signature.signature_image_at).toLocaleDateString() }} às
                  {{ new Date(view_signature.signature.signature_image_at).toLocaleTimeString().slice(0, -3) }}</small
                >
              </div>
            </v-tab-item>
            <v-tab-item v-if="view_signature.signature.signed_pdf_hash" class="s-signature-info">
              <div class="ssi-separator">
                <h3>Termo assinado:</h3>
                {{ view_signature.signature.title }}
              </div>
              <div class="ssi-separator">
                <h3>Assinado por:</h3>
                {{ view_signature.signature.signing_name }}
              </div>
              <div class="ssi-separator">
                <h3>Data de assinatura:</h3>
                {{ new Date(view_signature.signature.signature_image_at).toLocaleDateString() }} às
                {{ new Date(view_signature.signature.signature_image_at).toLocaleTimeString().slice(0, -3) }}
              </div>
              <div class="ssi-separator">
                <h3>Método de assinatura:</h3>
                {{ view_signature.signature.signature_method === 'in_person' ? 'Assinatura presencial' : 'Assinatura via link' }}
              </div>
              <div class="ssi-separator">
                <h3>IP do aparelho assinante:</h3>
                <div style="word-break: break-all">{{ view_signature.signature.signed_ip }}</div>
              </div>
              <div class="ssi-separator">
                <h3>Identificador do aparelho assinante:</h3>
                <div style="word-break: break-all">{{ view_signature.signature.signed_agent }}</div>
              </div>
              <div class="ssi-separator">
                <h3>Usuário que atrelou o termo ao checklist:</h3>
                <div style="word-break: break-all">{{ view_signature.signature.created_by_user.name }}</div>
              </div>
              <div class="ssi-separator">
                <h3>Código de segurança (SHA256):</h3>
                <div style="word-break: break-all; background-color: #48b38b; color: #fff; padding: 5px; border-radius: 10px">
                  {{ view_signature.signature.signed_pdf_hash }}
                </div>
              </div>
              <div class="ssi-separator">
                <h3>Identificador da assinatura:</h3>
                {{ view_signature.signature.hash }}
              </div>
              <div class="ssi-separator">
                <h3>Página para validação:</h3>
                <v-btn
                  @click="signatureLink(view_signature.signature.hash)"
                  class="mt-1"
                  elevation="0"
                  color="primary"
                  large
                  block
                >
                  <v-icon size="18" class="mr-2">mdi-whatsapp</v-icon>Compartilhar página de validação
                </v-btn>
              </div>
              <small
                >*O código de segurança é a comprovação da integridade do arquivo assinado, qualquer alteração no arquivo depois de assinado resultará
                um código diferente na comparação.</small
              >
            </v-tab-item>
            <v-tab-item v-else>
              <v-alert dense prominent text color="#48B38B">
                <div v-if="view_signature.signature.signature_method === 'link'">
                  Aguardando assinatura do cliente, clique no icone do WhatsApp para enviar o link.
                </div>
                <div v-else>
                  Assinatura em processamento. Caso persista por mais de 5 minutos, entre em contato com nosso suporte.
                </div>
              </v-alert>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
    </v-bottom-sheet>

    <BudgetDialog
      v-if="dialog_edit_budget.open && app_mode === 'advanced'"
      :dialog="dialog_edit_budget"
      @close-dialog="closeBudgetDialog"
      @delete-budget="deleteBudget"
    />

    <div v-if="app_mode === 'advanced'">
      <h3 class="my-2 mt-4">Leva e traz</h3>
      <div class="take-bring my-2">
        <div @click="handleOpenDialog" class="selector">
          <div class="bring-address">
            {{
              service_order.service_order_brings && service_order.service_order_brings.length > 0
                ? service_order.service_order_brings[0].address
                : 'Clique aqui para especificar o endereço do veículo...'
            }}
          </div>
          <img :src="require('@/assets/leva-e-traz.png')" />
        </div>
      </div>
    </div>

    <div>
      <h3 v-if="app_mode === 'advanced'" class="my-2 mt-5">Assinaturas</h3>
      <div v-if="service_order.client" class="add" @click="dialog_signature.status = true">ADICIONAR ASSINATURA</div>
      <div v-else>
        <v-alert color="#48B38B" dark border="left"> Especifique um cliente primeiro... </v-alert>
      </div>
      <div @click="selectSignature(signature)" v-for="signature in service_order_signatures" :key="signature.id" class="signature" :style="signature.signed_pdf_hash ? { borderLeft: '6px solid #48b38b' } : signature.signature_method === 'in_person' && !signature.signed_pdf_hash ? { borderLeft: '6px solid #ccc' } : { borderLeft: '6px solid #f39c12' }">
        <div class="s-details">
          <div class="s-title"><v-icon size="15">mdi-note-text</v-icon> {{ signature.title }}</div>
          <div class="s-name"><v-icon size="15">mdi-account</v-icon> {{ signature.signing_name }}</div>
        </div>
        <div class="signature-image">
          <small v-if="signature.signed_pdf_hash && signature.signature_method === 'link'" class="no-signature"
            >Assinado <br />
            via SMS/Whatsapp</small
          >
          <img v-if="signature.signed_pdf_hash && signature.signature_method !== 'link'" :src="signature.signature_image" />
          <div v-if="signature.signature_method === 'in_person' && !signature.signed_pdf_hash" class="no-signature"><v-icon>mdi-sync-circle</v-icon> Processando assinatura...</div>
          <div v-if="signature.signature_method === 'link' && !signature.signed_pdf_hash" class="no-signature"><v-icon>mdi-alert</v-icon> Aguardando assinatura via link...</div>
        </div>

        <div style="color: rgba(0, 0, 0, 0.6); padding: 12px; font-size: 12px;">
          <div v-if="signature.signed_pdf_hash">
            <v-icon size="15">mdi-calendar-month</v-icon> Assinado em
            {{ new Date(signature.signature_image_at).toLocaleDateString() }} às
            {{ new Date(signature.signature_image_at).toLocaleTimeString().slice(0, -3) }}
          </div>
          <div v-if="signature.signature_method === 'link' && !signature.signed_pdf_hash">
            <v-icon size="15">mdi-open-in-new</v-icon> Assinatura pendente, envie o link para o cliente.
          </div>
          <div v-if="signature.signature_method === 'in_person' && !signature.signed_pdf_hash">
            <v-icon size="15">mdi-file</v-icon> Arquivo sendo gerado, volte mais tarde por favor.
          </div>
        </div>
      </div>
    </div>

    <div v-if="app_mode === 'advanced'">
      <h3 class="my-2 mt-5">Orçamentos</h3>
      <div class="add" @click="dialog_link_budget.status = true">ATRELAR ORÇAMENTO</div>
      <div class="service-list-budgets">
        <div @click="openBudgetDialog(budget)" v-for="(budget, index) in service_order.budgets" :key="index" class="budget-card mb-4">
          <div class="budget-header">
            <span
              class="budget-status-chip"
              :style="{ backgroundColor: getBudgetStatus(budget.status).bgColor, color: getBudgetStatus(budget.status).textColor }"
            >
              {{ getBudgetStatus(budget.status).text }}
            </span>
            <span class="budget-visibility">
              <v-icon size="16" color="#667781">{{ budget.visible_client ? 'mdi-eye-outline' : 'mdi-eye-off-outline' }}</v-icon>
              {{ budget.visible_client ? 'Visível para o cliente' : 'Não visível para o cliente' }}
            </span>
          </div>

          <v-divider class="budget-divider"></v-divider>

          <div class="budget-info-row">
            <span class="budget-responsible">
              <v-icon size="18" color="#667781">mdi-account</v-icon>
              {{ budget.responsible_id || budget.responsible ? (budget.responsible_name || budget.responsible?.name) : 'Sem responsável' }}
            </span>
            <span class="budget-date-info">
              <v-icon size="16" color="#667781">mdi-calendar</v-icon>
              {{ budget.date ? formatDate(budget.date) : 'Sem data' }}
            </span>
          </div>

          <v-divider v-if="budget.observation" class="budget-divider"></v-divider>

          <div v-if="budget.observation" class="budget-description">
            {{ budget.observation }}
          </div>

          <v-divider class="budget-divider"></v-divider>

          <div class="budget-financial">
            <div class="financial-row">
              <span class="financial-label">Subtotal</span>
              <span class="financial-dots"></span>
              <span class="financial-value">{{ formatCurrency(calculateSubTotal(budget)) }}</span>
            </div>

            <div v-if="hasAnyDiscount(budget)" class="financial-group">
              <div class="financial-row">
                <span class="financial-label financial-label-icon">
                  <v-icon size="16" color="#e53e3e" class="financial-icon">mdi-percent-circle-outline</v-icon>
                  <b>Desconto</b>
                </span>
                <span class="financial-dots"></span>
                <span class="financial-value discount-color">- {{ calculateDiscount(budget) }}</span>
              </div>
              <div class="financial-breakdown">
                <div v-if="hasServicesDiscount(budget)" class="breakdown-item">
                  <span class="breakdown-label">» Serviço</span>
                  <span class="breakdown-dots"></span>
                  <span class="breakdown-value">{{ getServicesDiscountDisplay(budget) }}</span>
                </div>
                <div v-if="hasProductsDiscount(budget)" class="breakdown-item">
                  <span class="breakdown-label">» Produto</span>
                  <span class="breakdown-dots"></span>
                  <span class="breakdown-value">{{ getProductsDiscountDisplay(budget) }}</span>
                </div>
                <div v-if="isLegacyMode(budget)" class="breakdown-item">
                  <span class="breakdown-label">» Geral</span>
                  <span class="breakdown-dots"></span>
                  <span class="breakdown-value">{{ getLegacyDiscountDisplay(budget) }}</span>
                </div>
              </div>
            </div>

            <div v-if="hasEntryValue(budget)" class="financial-row">
              <span class="financial-label financial-label-icon">
                <v-icon size="16" color="#48b38b" class="financial-icon">mdi-credit-card-outline</v-icon>
                <b>Adiantamento</b>
              </span>
              <span class="financial-dots"></span>
              <span class="financial-value entry-color">- {{ getEntryValueDisplay(budget) }}</span>
            </div>

            <v-divider class="financial-divider"></v-divider>

            <div class="financial-row financial-total">
              <span class="financial-label"><b>Total</b></span>
              <span class="financial-dots"></span>
              <span class="financial-value">{{ calculateTotal(budget) }}</span>
            </div>

            <div v-if="hasEntryValue(budget)" class="financial-row financial-remaining">
              <span class="financial-label">Restante a pagar</span>
              <span class="financial-dots"></span>
              <span class="financial-value entry-color">{{ calculateTotalRemaining(budget) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="false">
      <h3 class="my-2 mt-5">Garantias</h3>
      <v-alert color="#48B38B" dark border="left"> Este recurso estará disponível <b>em breve</b>. </v-alert>
    </div>

    <v-dialog v-model="isLoading" persistent width="300" class="loader-service-order">
      <v-card class="pt-5 pb-2" color="primary" dark>
        <v-card-text>
          Carregando orçamento...
          <v-progress-linear indeterminate color="white" class="mb-0 mt-2"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BudgetService from '@/services/api/budget';
import BudgetDialog from '@/components/Budget/Dialog';
import NewSignatureDialog from './Dialogs/SignatureDialog';
import TakeBringDialog from './Dialogs/TakeBringDialog';
import LinkBudgetDialog from './Dialogs/LinkBudgetDialog';

export default {
  name: 'Signatures',
  components: {
    NewSignatureDialog,
    TakeBringDialog,
    LinkBudgetDialog,
    BudgetDialog
  },
  computed: {
    service_order() {
      return this.$store.getters['ServiceOrder/intialDetails'];
    },
    service_order_signatures() {
      return this.$store.getters['ServiceOrder/service_order_signatures'];
    },
    app_mode() {
      return localStorage.getItem('app_mode') || 'advanced';
    }
  },
  data: () => ({
    dialog_signature: {
      status: false
    },
    dialog_link_budget: {
      status: false
    },
    dialog_take_bring: {
      status: false
    },
    dialog_edit_budget: {
      open: false
    },
    view_signature: {
      status: false,
      tab: 0,
      signature: null
    },
    organization_url: null,
    copy_alert: false,
    dialog_signature_disable: {
      status: false,
      loading: false
    },
    isLoading: false
  }),
  mounted() {
    const user = this.$store.getters['Auth/user'];
    const param = user?.organization?.organization_parameters?.find(
      (parameter) => parameter.code === 'ORGANIZATION_DOMAIN_URL'
    );
    this.organization_url = param?.value || null;
  },
  methods: {
    openBudgetDialog(budgetServiceOrder) {
      this.isLoading = true;

      BudgetService.getById(budgetServiceOrder.id)
        .then((response) => {
          const budget = response.data;

          this.$store.commit('ServiceOrder/ADD_BUDGET', budget);
          this.$store.commit('Budget/SET_SELECTED_BUDGET', budget);
          this.dialog_edit_budget.open = true;
          this.dialog_link_budget.status = false;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    closeBudgetDialog(budget) {
      this.dialog_edit_budget.open = false;
      this.$store.commit('ServiceOrder/UPDATE_BUDGET', budget);
      this.$store.dispatch('Budget/cleanSelectedBudget');
    },
    deleteBudget(budget) {
      this.$store.commit('ServiceOrder/REMOVE_BUDGET', budget);
      this.dialog_edit_budget.open = false;
    },
    replaceDescription(description, limit) {
      return !limit ? description.replace(/\n/g, '<br>') : `${description.substring(0, limit)}...`;
    },
    selectSignature(signature) {
      this.view_signature.status = true;
      this.view_signature.signature = signature;
    },
    closeSignatureDialog() {
      this.view_signature.status = false;
    },
    closeNewSignatureDialog() {
      this.dialog_signature.status = false;
    },
    closeTakeBringDialog() {
      this.dialog_take_bring.status = false;
    },
    closeLinkBudgetDialog() {
      this.dialog_link_budget.status = false;
    },
    whatsappShareSignature() {
      const linkSignature = `${this.organization_url}/os/${this.service_order.hash}`;
      window.open(`whatsapp://send?text=${linkSignature}`);
    },
    signatureLink(signatureHash) {
      const linkSignature = `${this.organization_url}/assinatura/validacao?hash=${signatureHash}`;
      window.open(`whatsapp://send?text=${linkSignature}`);
    },
    getBudgetStatus(statusRef) {
      const budgetStatus = [
        { value: 'pendente', text: 'Pendente', bgColor: '#fff3e0', textColor: '#e65100' },
        { value: 'aguardando_aprovacao', text: 'Aguardando aprovação', bgColor: '#fff8e1', textColor: '#f57f17' },
        { value: 'aguardando_pagamento', text: 'Aguardando pagamento', bgColor: '#e3f2fd', textColor: '#1565c0' },
        { value: 'em_andamento', text: 'Em andamento', bgColor: '#e8eaf6', textColor: '#283593' },
        { value: 'aprovado', text: 'Aprovado', bgColor: '#e8f5e9', textColor: '#2e7d32' },
        { value: 'cancelado', text: 'Cancelado', bgColor: '#ffebee', textColor: '#c62828' },
        { value: 'recusado', text: 'Recusado', bgColor: '#ffebee', textColor: '#c62828' }
      ];
      return budgetStatus.find((status) => status.value === statusRef) || { text: statusRef || 'Sem status', bgColor: '#f5f5f5', textColor: '#666' };
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },
    calculateEstimate(budget) {
      if (budget.total_estimate > 0) {
        const estimate = budget.total_estimate;

        if (estimate < 60) {
          return `${estimate} minutos`;
        }

        const hours = Math.floor(estimate / 60);
        const minutes = estimate % 60;

        return `${hours}h${minutes.toString().padStart(2, '0')}m`;
      }

      return 'Sem estimativa';
    },
    isLegacyMode(budget) {
      // Campos novos têm prioridade sobre os antigos
      const discountServices = budget.discount_services;
      const discountProducts = budget.discount_products;
      const discountTypeServices = budget.discount_type_services;
      const discountTypeProducts = budget.discount_type_products;

      const hasNewFields =
        (discountServices !== null && discountServices !== undefined) ||
        (discountProducts !== null && discountProducts !== undefined) ||
        (discountTypeServices !== null && discountTypeServices !== undefined && discountTypeServices !== '') ||
        (discountTypeProducts !== null && discountTypeProducts !== undefined && discountTypeProducts !== '');

      if (hasNewFields) return false;

      // Fallback para campos antigos
      const { discount, discount_type: discountType } = budget;

      const hasLegacyDiscount =
        discount !== null &&
        discount !== undefined &&
        discount !== '' &&
        discount !== 0 &&
        parseFloat(discount) > 0;

      const hasLegacyType =
        discountType !== null &&
        discountType !== undefined &&
        discountType !== '';

      return hasLegacyDiscount || hasLegacyType;
    },
    getServicesTotal(budget) {
      if (!budget?.budget_services?.length) return 0;
      return budget.budget_services
        .filter((service) => service.disaproved_by_client !== true)
        .reduce((acc, service) => {
          const amount = parseInt(service.amount, 10) || 0;
          const unitaryValue = parseFloat(service.unitary_value) || 0;
          const totalValue = parseFloat(service.total_value) || 0;
          const calculatedTotal = amount * unitaryValue;
          return acc + (totalValue > 0 ? totalValue : calculatedTotal);
        }, 0);
    },
    getProductsTotal(budget) {
      if (!budget?.budget_products?.length) return 0;
      return budget.budget_products
        .filter((product) => product.disaproved_by_client !== true)
        .reduce((acc, product) => {
          const amount = parseInt(product.amount, 10) || 0;
          const unitaryValue = parseFloat(product.unitary_value) || 0;
          const totalValue = parseFloat(product.total_value) || 0;
          const calculatedTotal = amount * unitaryValue;
          return acc + (totalValue > 0 ? totalValue : calculatedTotal);
        }, 0);
    },
    hasAnyDiscount(budget) {
      if (this.isLegacyMode(budget)) {
        const discount = parseFloat(budget.discount) || 0;
        return discount > 0;
      }
      const discountServices = parseFloat(budget.discount_services) || 0;
      const discountProducts = parseFloat(budget.discount_products) || 0;
      return discountServices > 0 || discountProducts > 0;
    },
    hasServicesDiscount(budget) {
      if (this.isLegacyMode(budget)) return false;
      const discountServices = parseFloat(budget.discount_services) || 0;
      return discountServices > 0;
    },
    hasProductsDiscount(budget) {
      if (this.isLegacyMode(budget)) return false;
      const discountProducts = parseFloat(budget.discount_products) || 0;
      return discountProducts > 0;
    },
    getServicesDiscountDisplay(budget) {
      if (!this.hasServicesDiscount(budget)) return '';
      const discountServices = parseFloat(budget.discount_services) || 0;
      const type = budget.discount_type_services;

      if (type === 'percentual') {
        const calculatedValue = this.getServicesTotal(budget) * (discountServices / 100);
        return `${this.formatCurrency(calculatedValue)} (${discountServices}%)`;
      }
      return this.formatCurrency(discountServices);
    },
    getProductsDiscountDisplay(budget) {
      if (!this.hasProductsDiscount(budget)) return '';
      const discountProducts = parseFloat(budget.discount_products) || 0;
      const type = budget.discount_type_products;

      if (type === 'percentual') {
        const calculatedValue = this.getProductsTotal(budget) * (discountProducts / 100);
        return `${this.formatCurrency(calculatedValue)} (${discountProducts}%)`;
      }
      return this.formatCurrency(discountProducts);
    },
    getLegacyDiscountDisplay(budget) {
      if (!this.isLegacyMode(budget) || !this.hasAnyDiscount(budget)) return '';
      const { discount, discount_type: discountType } = budget;

      if (discountType === 'percentual') {
        const subtotal = this.calculateSubTotal(budget);
        const calculatedValue = subtotal * (discount / 100);
        return `${this.formatCurrency(calculatedValue)} (${discount}%)`;
      }
      return this.formatCurrency(discount);
    },
    hasEntryValue(budget) {
      const entryValue = parseFloat(budget.entry_value) || 0;
      return entryValue > 0;
    },
    getEntryValueDisplay(budget) {
      if (!this.hasEntryValue(budget)) return '';
      return this.formatCurrency(budget.entry_value);
    },
    calculateTotalRemaining(budget) {
      const totalValue = this.parseCurrency(this.calculateTotal(budget));
      const entryValue = parseFloat(budget.entry_value) || 0;
      return this.formatCurrency(totalValue - entryValue);
    },
    calculateDiscount(budget) {
      if (this.isLegacyMode(budget)) {
        const discountType = budget.discount_type;
        const subtotal = this.calculateSubTotal(budget);
        const { discount } = budget;

        if (discount) {
          if (discountType === 'percentual') {
            let discountedAmount;

            if (typeof discount === 'string') {
              const cleanedDiscount = discount.replace(/[^\d,.-]/g, '');
              const parsedDiscount = parseFloat(cleanedDiscount.replace(',', '.'));

              discountedAmount = subtotal * (parsedDiscount / 100);
            } else {
              discountedAmount = subtotal * (discount / 100);
            }

            return this.formatCurrency(discountedAmount);
          }

          return this.formatCurrency(discount);
        }

        return this.formatCurrency(0);
      }

      let totalDiscount = 0;

      const discountServices = parseFloat(budget.discount_services) || 0;
      const discountTypeServices = budget.discount_type_services;
      if (discountServices > 0) {
        totalDiscount +=
          discountTypeServices === 'percentual'
            ? this.getServicesTotal(budget) * (discountServices / 100)
            : discountServices;
      }

      const discountProducts = parseFloat(budget.discount_products) || 0;
      const discountTypeProducts = budget.discount_type_products;
      if (discountProducts > 0) {
        totalDiscount +=
          discountTypeProducts === 'percentual'
            ? this.getProductsTotal(budget) * (discountProducts / 100)
            : discountProducts;
      }

      return this.formatCurrency(totalDiscount);
    },
    calculateSubTotal(budget) {
      return this.getServicesTotal(budget) + this.getProductsTotal(budget);
    },
    calculateTotal(budget) {
      const subTotal = this.calculateSubTotal(budget);
      const discount = this.calculateDiscount(budget);

      return this.formatCurrency(subTotal - this.parseCurrency(discount));
    },
    parseCurrency(value) {
      return value ? parseFloat(value.replace('R$', '').replace('.', '').replace(',', '.').trim()) : 0;
    },
    formatCurrency(amount) {
      return amount ? parseFloat(amount).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 'R$ 0,00';
    },
    handleOpenDialog() {
      this.dialog_take_bring.status = true;
    },
    disableSignature() {
      this.dialog_signature_disable.loading = true;
      this.$store.dispatch('Budget/cleanSelectedBudget');
      this.$http.delete(`/service_order/${this.service_order.id}/signature/${this.view_signature.signature.hash}/disable`).then(() => {
        this.$store.dispatch('ServiceOrder/removeSignature', this.view_signature.signature.hash);
        this.closeSignatureDialog();
        this.dialog_signature_disable = {
          status: false,
          loading: false
        };
      });
    }
  },
  watch: {
    'view_signature.status': {
      handler(status) {
        if (!status) {
          this.view_signature.tab = 0;
          this.view_signature.signature = null;
        }
      }
    }
  }
};
</script>

<style lang="scss">
.service-signatures {
  .take-bring {
    .selector {
      background-color: #eeeeee;
      padding: 6px 8px;
      border-radius: 6px;
      overflow: hidden;

      .bring-address {
        float: left;
        width: calc(100% - 105px);
        padding: 10px;
        color: #8f8f8f;
        font-size: 13px;
      }

      img {
        float: right;
        width: 105px;
        height: auto;
        background-color: #fff;
        padding: 16px 12px;
        border-radius: 6px;
      }
    }
  }

  .add {
    text-align: center;
    border: 1px dashed rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    padding: 10px 20px;
  }

  .signature {
    margin-top: 15px;
    border-radius: 6px;
    border: 2px solid #eee;
    overflow: hidden;

    .s-details {
      padding: 12px 12px 0px 12px;
      overflow: hidden;
      width: 100%;

      .s-title {
        font-weight: bold;
        font-size: 12px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      .s-name {
        font-size: 20px;
        padding: 10px 0px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    .signature-image {
      float: left;
      padding: 0px 10px 6px 10px;
      width: -webkit-fill-available;

      .no-signature {
        width: 100%;
        background-color: #eee;
        padding: 10px;
        display: block;
        text-transform: uppercase;
        text-align: center;
        font-weight: 500;
        padding: 19px;
        margin-bottom: 8px;
        border-radius: 6px;
        font-size: 13px;
      }

      img {
        width: 100%;
        background-color: #eee;
        border-radius: 6px;
        padding: 10px;
      }
    }
  }

  .service-list-budgets {
    margin-top: 15px;
    width: 100%;

    .budget-card {
      padding: 16px 18px;
      border: 1.5px solid #e0e0e0;
      border-radius: 10px;
      background: #fff;

      .budget-header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .budget-status-chip {
          font-size: 13px;
          font-weight: 600;
          padding: 4px 14px;
          border-radius: 20px;
          white-space: nowrap;
        }

        .budget-visibility {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 12px;
          color: #667781;
          font-weight: 400;
        }
      }

      .budget-divider {
        margin: 10px 0;
      }

      .budget-info-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 0 6px 0;

        .budget-responsible {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 14px;
          color: #2d3748;
          font-weight: 500;
        }

        .budget-date-info {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 13px;
          color: #667781;
          font-weight: 400;
        }
      }

      .budget-description {
        font-size: 14px;
        color: #4a5568;
        line-height: 1.5;
        padding: 8px 0 4px 0;
        word-break: break-word;
      }

      .budget-financial {
        .financial-row {
          display: flex;
          align-items: center;
          padding: 5px 0;

          .financial-label {
            font-size: 14px;
            color: #4a5568;
            white-space: nowrap;
          }

          .financial-label-icon {
            display: flex;
            align-items: center;

            .financial-icon {
              margin-right: 4px;
            }
          }

          .financial-dots {
            flex: 1;
            border-bottom: 1px dotted #cbd5e0;
            margin: 0 8px;
            height: 1px;
            min-width: 20px;
          }

          .financial-value {
            font-size: 14px;
            font-weight: 600;
            color: #2d3748;
            white-space: nowrap;
          }
        }

        .financial-group {
          margin: 2px 0;
        }

        .financial-breakdown {
          padding: 2px 0 4px 16px;

          .breakdown-item {
            display: flex;
            align-items: center;
            padding: 2px 0;

            .breakdown-label {
              font-size: 12px;
              color: #a0aec0;
              white-space: nowrap;
            }

            .breakdown-dots {
              flex: 1;
              border-bottom: 1px dotted #e2e8f0;
              margin: 0 6px;
              height: 1px;
              min-width: 10px;
            }

            .breakdown-value {
              font-size: 12px;
              font-weight: 500;
              color: #a0aec0;
              white-space: nowrap;
            }
          }
        }

        .discount-color {
          color: #e53e3e !important;
        }

        .entry-color {
          color: #48b38b !important;
        }

        .financial-divider {
          margin: 6px 0;
        }

        .financial-total {
          padding-top: 6px;

          .financial-label {
            font-size: 15px;
            font-weight: 700;
            color: #1a202c;
          }

          .financial-value {
            font-size: 15px;
            font-weight: 700;
            color: #1a202c;
          }
        }

        .financial-remaining {
          padding: 2px 0 0 0;

          .financial-label {
            font-size: 12px;
            color: #a0aec0;
          }

          .financial-value {
            font-size: 12px;
            font-weight: 600;
          }
        }
      }
    }
  }
}

.signed-dialog {
  height: 600px;
  overflow: auto;
  background-color: #fff;

  .s-header {
    padding: 10px 20px;
    background-color: #e1e1e1;
    overflow: hidden;
    width: -webkit-fill-available;
    position: absolute;
    z-index: 999;

    .action-btn {
      float: right;
      background-color: #c7c7c7;
      border-radius: 50%;
      padding: 7px;
    }

    .whatsapp-share {
      float: right;
      background-color: #48b38b;
      border-radius: 50%;
      padding: 7px;
    }

    h2 {
      color: rgba(0, 0, 0, 0.6) !important;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 210px;
    }
  }

  .s-tabs {
    margin-top: 58px;
    overflow: hidden;
    width: -webkit-fill-available;
    position: absolute;
    z-index: 999;

    .v-tab {
      margin: 0 !important;
    }
  }

  .s-content {
    padding: 125px 20px 60px 20px;

    .s-signature-info {
      .ssi-separator {
        margin-bottom: 10px;
        padding-bottom: 10px;
        border-bottom: 1px solid #eee;
      }
    }

    .s-signature-area {
      text-align: center;
      padding-top: 26px;

      img {
        width: -webkit-fill-available;
        margin-bottom: -24px;
      }
    }
  }
}
</style>
